<template>
  <div class="gamanza-avatar-wrapper" :class="{
    'gamanza-avatar-wrapper--summary': showSummary,
    'gamanza-avatar-wrapper--compact-summary': compactSummary
  }"
    :style="{ '--primary-color': primaryColor, '--primary-rgb': primaryColorRgb }" ref="avatarWrapper">
    <div v-if="!widgetLoaded" class="avatar px-1 py-1 pb-0" @click.stop="handleWidgetClick">
      <i class="fa fa-user fa-2x fa-inverse"></i>
    </div>
    <div v-if="showSummary && widgetLoaded" class="gamanza-avatar-summary" @click.stop="handleWidgetClick">
      <div :id="headerLevelWidgetId" class="gamification_widget gamanza-avatar-summary__widget gamanza-avatar-summary__widget--level"
        data-type="badge-level" data-size="small"></div>
      <div :id="headerTokensWidgetId" class="gamification_widget gamanza-avatar-summary__widget"
        data-type="tokens" :data-text-color="summaryTextColor"></div>
    </div>
    <div v-if="showLevelBadge && !showSummary && widgetLoaded" class="gamanza-avatar-level-badge"
      @click.stop="handleWidgetClick">
      <div :id="headerLevelWidgetId" class="gamification_widget" data-type="badge-level" data-size="small"></div>
    </div>
    <div v-show="widgetLoaded" :id="widgetId" class="gamification_widget gamanza-avatar-widget" data-type="avatar"
      data-size="50" data-progress-type="level" @click.stop="handleWidgetClick"></div>

    <transition name="tooltip-fade">
      <div v-if="showTooltip" class="gamanza-tooltip" @click.stop
        :style="{ '--primary-color': primaryColor, '--primary-rgb': primaryColorRgb, '--bg-dark': bgColor }">
        <div class="tooltip-header">
          <i class="fas fa-gamepad"></i>
          <span>Mi Perfil</span>
        </div>
        <div class="tooltip-stats">
          <div class="stat-item">
            <span class="stat-label">Rango</span>
            <div :id="rankWidgetId" class="gamification_widget stat-widget"
              data-type="gamification-data" data-gamification-type="rank" data-show-name="true"></div>
          </div>
          <div class="stat-item">
            <span class="stat-label">Nivel</span>
            <div :id="levelWidgetId" class="gamification_widget stat-widget"
              data-type="gamification-data" data-gamification-type="level" data-show-name="true"></div>
          </div>
          <div class="stat-item">
            <span class="stat-label">Tokens</span>
            <div :id="tokensWidgetId" class="gamification_widget stat-widget"
              data-type="gamification-data" data-gamification-type="token" data-show-name="true"></div>
          </div>
          <div class="stat-item stat-item-xp">
            <span class="stat-label">XP</span>
            <div :id="xpWidgetId" class="gamification_widget stat-widget"
              data-type="gamification-data" data-gamification-type="xp" data-progress-type="rank"></div>
          </div>
        </div>
        <div class="tooltip-links">
          <div v-if="showMissions" class="tooltip-link" @click.stop="openMissions">
            <i class="fas fa-tasks"></i>
            <span>Misiones</span>
            <i class="fas fa-chevron-right arrow"></i>
          </div>
          <div v-if="showTournaments" class="tooltip-link" @click.stop="openTournaments">
            <i class="fas fa-trophy"></i>
            <span>Torneos</span>
            <i class="fas fa-chevron-right arrow"></i>
          </div>
          <div v-if="showRewardShop" class="tooltip-link" @click.stop="openRewardShop">
            <i class="fas fa-gift"></i>
            <span>Tienda de recompensas</span>
            <i class="fas fa-chevron-right arrow"></i>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import gamanzaWidgetService from '@/services/gamanzaWidgetService';

export default {
  name: 'GamanzaAvatar',
  props: {
    skin: {
      type: Object,
      required: true
    },
    language: {
      type: String,
      default: 'es'
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    compactSummary: {
      type: Boolean,
      default: false
    },
    showLevelBadge: {
      type: Boolean,
      default: false
    },
    externalPanel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      widgetLoaded: false,
      showTooltip: false,
      widgetId: `gamanza-avatar-widget-${this._uid}`,
      headerLevelWidgetId: `gamanza-header-level-widget-${this._uid}`,
      headerTokensWidgetId: `gamanza-header-tokens-widget-${this._uid}`,
      rankWidgetId: `gamanza-rank-widget-${this._uid}`,
      levelWidgetId: `gamanza-level-widget-${this._uid}`,
      tokensWidgetId: `gamanza-tokens-widget-${this._uid}`,
      xpWidgetId: `gamanza-xp-widget-${this._uid}`
    }
  },
  computed: {
    primaryColor() {
      return this.skin?.gamanza?.lookAndFeel?.palette?.primary?.main || '#DA4167';
    },
    primaryColorRgb() {
      const hex = this.primaryColor.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `${r}, ${g}, ${b}`;
    },
    bgColor() {
      return this.skin?.gamanza?.lookAndFeel?.palette?.background?.default || '#040713';
    },
    summaryTextColor() {
      return this.skin?.gamanza?.lookAndFeel?.palette?.text?.primary || '#FFFFFF';
    },
    showMissions() {
      return Boolean(this.skin?.gamanza?.mainFrame?.missions);
    },
    showTournaments() {
      return Boolean(this.skin?.gamanza?.mainFrame?.tournaments);
    },
    showRewardShop() {
      return Boolean(this.skin?.gamanza?.mainFrame?.rewardShop);
    }
  },
  mounted() {
    this.renderWidget();
    document.addEventListener('click', this.closeTooltip);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeTooltip);
  },
  methods: {
    handleWidgetClick() {
      if (this.externalPanel) {
        this.$emit('open-panel');
        return;
      }

      this.toggleTooltip();
    },
    renderWidget() {
      this.widgetLoaded = false;
      this.$nextTick(() => {
        setTimeout(() => {
          gamanzaWidgetService.reloadOne(this.widgetId);
          this.checkWidgetLoaded();
        }, 1000);
      });
    },
    checkWidgetLoaded() {
      let attempts = 0;
      const check = () => {
        attempts++;
        const el = document.getElementById(this.widgetId);
        if (el && el.children.length > 0) {
          this.widgetLoaded = true;
          this.reloadHeaderSummary();
        } else if (attempts < 10) {
          setTimeout(check, 500);
        }
      };
      setTimeout(check, 500);
    },
    reloadHeaderSummary() {
      if (!this.showSummary && !this.showLevelBadge) return;

      this.$nextTick(() => {
        setTimeout(() => {
          gamanzaWidgetService.reloadOne(this.headerLevelWidgetId);
          if (this.showSummary) {
            gamanzaWidgetService.reloadOne(this.headerTokensWidgetId);
          }
        }, 300);
      });
    },
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
      if (this.showTooltip) {
        this.$nextTick(() => {
          setTimeout(() => {
            gamanzaWidgetService.reloadOne(this.rankWidgetId);
            gamanzaWidgetService.reloadOne(this.levelWidgetId);
            gamanzaWidgetService.reloadOne(this.tokensWidgetId);
            gamanzaWidgetService.reloadOne(this.xpWidgetId);
          }, 300);
        });
      }
    },
    closeTooltip() {
      this.showTooltip = false;
    },
    openMissions() {
      this.showTooltip = false;
      this.$emit('open-missions');
    },
    openTournaments() {
      this.showTooltip = false;
      this.$emit('open-tournaments');
    },
    openRewardShop() {
      this.showTooltip = false;
      this.$emit('open-reward-shop');
    }
  },
  watch: {
    language() {
      this.renderWidget();
    },
    showSummary(isVisible) {
      if (isVisible && this.widgetLoaded) {
        this.reloadHeaderSummary();
      }
    },
    showLevelBadge(isVisible) {
      if (isVisible && this.widgetLoaded) {
        this.reloadHeaderSummary();
      }
    }
  }
}
</script>

<style scoped>
.gamanza-avatar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  min-height: 26px;
  position: relative;
}

.gamanza-avatar-widget {
  margin: 0 2px 0 0;
  transform: scale(0.9);
  transform-origin: center;
}

.gamanza-avatar-level-badge {
  position: absolute;
  right: -7px;
  bottom: -5px;
  z-index: 2;
  display: flex;
  align-items: center;
  min-width: 22px;
  min-height: 18px;
  transform: scale(0.82);
  transform-origin: right bottom;
}

.gamanza-avatar-wrapper--summary {
  min-width: 104px;
  min-height: 52px;
  height: 52px;
  box-sizing: border-box;
  padding: 4px 6px 4px 16px;

}

.gamanza-avatar-summary {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-height: 52px;
  min-width: 28px;
  padding-left: 9px;
  cursor: pointer;
}

.gamanza-avatar-summary::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 3px;
  height: 36px;
  content: '';
  background: var(--primary-color);
  border-radius: 2px;
  transform: translateY(-50%);
}

.gamanza-avatar-summary__widget {
  display: flex;
  align-items: center;
  min-width: 0;
}

.gamanza-avatar-summary__widget--level {
  transform: translateX(-2px) scale(1.17);
  transform-origin: left center;
}

.gamanza-avatar-summary__widget--level::v-deep [class*='levelContent'] {
  border: 0 !important;
  border-radius: 0;
  display: flex;
  padding-left: 2px;
  justify-content: flex-start;
}

@media (max-width: 1200px) {
  .gamanza-avatar-wrapper--compact-summary {
    gap: 4px;
    min-width: 68px;
    min-height: 50px;
    height: 50px;
    box-sizing: border-box;
    padding: 0;
    background: transparent;
  }

  .gamanza-avatar-wrapper--compact-summary .gamanza-avatar-widget {
    flex: 0 0 50px;
    width: 50px;
    margin: 0 0 0 -24px;
    transform: scale(0.8);
    transform-origin: center;
  }

  .gamanza-avatar-wrapper--compact-summary .gamanza-avatar-summary {
    gap: 3px;
    min-height: 36px;
    min-width: 30px;
    padding-left: 15px;
  }

  .gamanza-avatar-wrapper--compact-summary .gamanza-avatar-summary::before {
    width: 2px;
    height: 26px;
  }

  .gamanza-avatar-wrapper--compact-summary .gamanza-avatar-summary__widget {
    transform: scale(0.78);
    transform-origin: left center;
  }

  .gamanza-avatar-wrapper--compact-summary .gamanza-avatar-summary__widget--level {
    transform: translateX(-1px) scale(0.82);
  }
}

.gamanza-tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 10px;
  background: linear-gradient(145deg, #1e1e32, #16162a);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px;
  min-width: 300px;
  max-width: 360px;
  z-index: 9999;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.05);
  overflow: hidden;
}

@media (max-width: 799px) {
  .gamanza-tooltip {
    /* The avatar sits within the mobile header, so anchor the panel to the viewport. */
    position: fixed;
    top: 58px;
    right: 8px;
    left: 8px;
    margin-top: 0;
    min-width: 0;
    max-width: none;
    box-sizing: border-box;
  }
}

.gamanza-tooltip::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: #1e1e32;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  transform: rotate(45deg);
}

.tooltip-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.tooltip-header i {
  color: var(--primary-color);
  font-size: 14px;
}

.tooltip-header span {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.tooltip-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 14px;
}

.stat-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  transition: background 0.2s ease;
  overflow: hidden;
}

.stat-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.stat-item-xp {
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}

.stat-item-xp .stat-label {
  margin-bottom: 2px;
}

.stat-label {
  color: #8a8a9a;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.stat-widget {
  transform: none;
  margin: 0;
  top: 0;
  max-width: 100%;
  overflow: hidden;
}

.tooltip-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tooltip-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  color: #b0b0c0;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  background: transparent;
}

.tooltip-link:hover {
  background: linear-gradient(135deg, rgba(var(--primary-rgb), 0.15), rgba(var(--primary-rgb), 0.08));
  color: #fff;
  transform: translateX(4px);
}

.tooltip-link i {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--primary-color);
  background: rgba(var(--primary-rgb), 0.15);
  border-radius: 6px;
  transition: all 0.2s ease;
}

.tooltip-link:hover i {
  background: rgba(var(--primary-rgb), 0.25);
  transform: scale(1.1);
}

.tooltip-link span {
  flex: 1;
}

.tooltip-link .arrow {
  opacity: 0;
  transform: translateX(-4px);
  transition: all 0.2s ease;
  color: var(--primary-color);
  font-size: 10px;
}

.tooltip-link:hover .arrow {
  opacity: 1;
  transform: translateX(0);
}

.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.tooltip-fade-enter,
.tooltip-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.98);
}
</style>
